/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';

export interface ArticleNoteHeaderAttrs extends ComponentAttrs {}

export default class ArticleNoteHeader<CustomAttrs extends ArticleNoteHeaderAttrs = ArticleNoteHeaderAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		return (
			<div className="ArticleNoteHeader">
				<label>{app.translator.trans('glowingblue-orell-bookshelf.forum.article_note.label')}</label>
				<span>
					{icon('far fa-lock-alt')} {app.translator.trans('glowingblue-orell-bookshelf.forum.article_note.private')}
				</span>
			</div>
		);
	}
}
